// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__UaiNW","itemTitle":"ClientEmergencyInfo_itemTitle__CRdHu","itemText":"ClientEmergencyInfo_itemText__4PtqG"};